const faqContainers = document.querySelectorAll('[data-faq-container]')

for (let i = 0; i < faqContainers.length; i++) {
  const toggle = faqContainers[i].querySelector('[data-faq-toggle]')
  const panel = faqContainers[i].querySelector('[data-faq-panel]')

  if (toggle !== null) {
    toggle.onclick = function(e) {
      e.preventDefault();

      // Toggle icon classes (e.g. opacity-0 on the plus icon)
      const toggleItems = faqContainers[i].querySelectorAll('[data-faq-toggle-class]')
      for (let j = 0; j < toggleItems.length; j++) {
        const toggleClass = toggleItems[j].getAttribute('data-faq-toggle-class')
        toggleItems[j].classList.toggle(toggleClass)
      }

      // Slide panel open/closed
      if (panel !== null) {
        const isOpen = parseFloat(panel.style.maxHeight) > 0
        panel.style.transition = 'max-height 0.3s ease-in-out'
        if (isOpen) {
          // Pin to current height, force reflow, then collapse
          panel.style.maxHeight = panel.scrollHeight + 'px'
          panel.getBoundingClientRect()
          panel.style.maxHeight = '0'
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        }
      }
    }
  }
}
